<template>
    <div id="tab-history" class="tab">
        <ul class="profile-history">
            <li  v-for="(item, index) in employee.history" :class="!index ? 'current' : ''" :key="index">
                <time :datetime="item.date" class="time">{{item.date}}</time>
                <p>{{item.text}}</p></li>
        </ul>
    </div>
</template>

<script>

    export default {
        name: 'current-employee-history',
        data() {
            return {

            }
        },
        props: {
            employee: Object,
        },
        methods: {

        },
    }
</script>

<style scoped>
    #tab-history {
        display: block;
    }
</style>
